module.exports = __webpack_public_path__ + "coin-e2683583.webp";